import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { LoginScreen, ForgotPasswordScreen, ResetPasswordScreen } from "@/components/auth/AuthScreens";
import Dashboard from "@/pages/Dashboard";
import Analytics from "@/pages/Analytics";
import Backoffice from "@/pages/Backoffice";
import KPISettings from "@/pages/KPISettings";
import { Toaster } from "@/components/ui/sonner";

function ProtectedRoute({ children, requireRole }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireRole && user.role !== requireRole) return <Navigate to="/" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<PublicOnly><LoginScreen /></PublicOnly>} />
              <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
              <Route path="/reset-password" element={<ResetPasswordScreen />} />
              <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/graficos" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
              <Route path="/utilizadores" element={<ProtectedRoute requireRole="superadmin"><Backoffice /></ProtectedRoute>} />
              <Route path="/definicoes-kpi" element={<ProtectedRoute><KPISettings /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" richColors />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
